var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-familles"},[_vm._l((_vm.getFamillesSvg),function(svg){return [_c('div',{domProps:{"innerHTML":_vm._s(svg)}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }